import { State } from 'src/types'
import { catchFaceOfNormal } from './catchFaceOfNormal'

export const catchFaceDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color
  catchFaceOfNormal(ctx, state.catchFace.color, state.stitch.color)
}
